/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import { SkinnyUserAttributeValueFragmentFragmentDoc } from '../../../models/generated/SkinnyUserAttributeValueFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SessionUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SessionUserQuery = { me: { id: number, email?: string | undefined, timezone: string, firstname: string, lastname: string, displayName: string, phone?: string | undefined, language: { code: string, localizedLabel: string, translatedLabel: string }, lastLoginAt?: { local: string } | undefined, attributes: Array<{ name: string, value: string, valueId: number, attributeId: number, isMainHierarchyHead: boolean, parent?: { attributeId: number, valueId: number } | undefined, children: Array<{ attributeId: number, valueId: number }> }>, permissions: Array<{ isGranted: boolean, permission: { code: Types.UserPermissionCode } }> } };


export const SessionUserDocument = gql`
    query SessionUser {
  me {
    id
    firstname: first_name
    lastname: last_name
    displayName: display_name
    email
    phone: phone_number
    language {
      code
      localizedLabel: localized_label
      translatedLabel: translated_label
    }
    lastLoginAt {
      local
    }
    timezone
    attributes {
      ...SkinnyUserAttributeValueFragment
    }
    permissions {
      isGranted
      permission {
        code
      }
    }
  }
}
    ${SkinnyUserAttributeValueFragmentFragmentDoc}`;

/**
 * __useSessionUserQuery__
 *
 * To run a query within a React component, call `useSessionUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionUserQuery(baseOptions?: Apollo.QueryHookOptions<SessionUserQuery, SessionUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionUserQuery, SessionUserQueryVariables>(SessionUserDocument, options);
      }
export function useSessionUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionUserQuery, SessionUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionUserQuery, SessionUserQueryVariables>(SessionUserDocument, options);
        }
export type SessionUserQueryHookResult = ReturnType<typeof useSessionUserQuery>;
export type SessionUserLazyQueryHookResult = ReturnType<typeof useSessionUserLazyQuery>;
export type SessionUserQueryResult = Apollo.QueryResult<SessionUserQuery, SessionUserQueryVariables>;